import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const splideRoot = document.querySelector('.splide');
if (splideRoot) {
  const splide = new Splide(splideRoot, {
    type: 'loop',
    drag: 'free',
    focus: 'center',
    perPage: 4,
    autoScroll: {
      speed: 0.3,
    },
    extensions: { AutoScroll },
    breakpoints: {
      600: {
        perPage: 1,
        height: '6rem',
      },
    },
  });

  splide.mount({ AutoScroll });
}

const splideHashRoot = document.querySelector('.splide.hashNavigationOne');
if (splideHashRoot) {
  const splideHashOne = new Splide(splideHashRoot, {
    perPage: 3,
    perMove: 1,
    focus: 'center',
    drag: 'free',
    breakpoints: {
      600: {
        perPage: 2,
        height: '6rem',
      },
    },
  });

  splideHashOne.mount();
}
